<template>
  <div class="new_fiat">
      <div class="steps_box">
        <!-- 步骤条 -->
        <div class="step1">
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/dui_icon.png" alt="">
                    <img class="s_img2" src="../../../assets/img/xian1.png" alt="">
                </div>
                <div class="div1">{{$t('main.text389')}}</div>
            </div>
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/num2.png" alt="">
                    <img class="s_img2" src="../../../assets/img/xian2.png" alt="">
                </div>
                <div class="div1">{{$t('main.text365')}}</div>
            </div>
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/num3.png" alt="">
                </div>
                <div class="div1">{{$t('main.text390')}}</div>
            </div>
        </div>
        <!-- ----- -->

        <div class="zdy_table_list">
            <div class="table_btm">
                <div class="table_btm_t1">{{$t('main.text391')}}</div>
                <el-button class="add_btn border_set_color" icon="el-icon-plus" @click="add_btn">{{$t('main.text392')}}</el-button>
            </div>
            <div class="table_btm2">
                <div class="list_title1">{{$t('main.text378')}}</div>
                <table class="list_table">
                    <div v-for="(item,index) in tableData" :key="index">
                        <div class="td1">
                            <el-checkbox-group v-model="checkList" @change="checkbox_fun(item)">
                                <el-checkbox :label="item.name">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="td_addr td2">{{item.address}}</div>
                        <div class="td3">{{item.type}}</div>
                        <div>
                            <el-popover
                                placement="bottom-end"
                                popper-class="operate_pop"
                                width="100"
                                trigger="hover">
                                <div class="text_r" slot="reference">
                                    <img class="sand_img" src="../../../assets/img/sand.png" alt="">
                                </div>
                                <div>
                                    <div class="edit_btn" @click="edit_fun(item)">{{$t('main.text71')}}</div>
                                    <div class="delete_btn" @click="delete_fun(item)">{{$t('main.text363')}}</div>
                                </div>
                            </el-popover>
                        </div>
                    </div>
                    <span v-if="page_total<=0" class="no_data_text">{{$t('main.text364')}}</span>
                </table>
                <el-pagination
                v-if="tableData.length > 0"
                background
                :page-sizes="[10, 20, 30, 40]"
                :page-size="limit"
                :current-page.sync="currentPage"
                layout="prev, pager, next"
                :total="page_total"
                @current-change="current_change"
                ></el-pagination>

            </div>
        </div>

        <div v-if="addr_box_show">
            <!-- 竖线 -->
            <img class="shuxian" src="../../../assets/img/shuxian.png" alt="">
        </div>

        <div v-if="addr_box_show" class="zdy_table_list">

            <!-- 第三行数据 -->
            <div class="table_btm table_btm3">
                <div class="table_btm_t1">{{$t('main.text365')}}</div>
                
                <div class="alert_box">
                    <el-alert
                        class="alert_style"
                        type="warning"
                        :closable="false"
                        show-icon>
                        <div slot="title" class="alert_text">
                            {{$t('main.text488')}}
                        </div>
                    </el-alert>
                </div>

                <el-form class="step1_form zdy_form_style" label-position="top">
                    <!-- 1 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text348')">
                                <el-input v-model="add_form.name"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item :label="$t('main.text366')">
                                <el-input v-model="add_form.addr"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <!-- 2 -->
                    <div class="d_row">
                        <div>
                            <el-form-item :label="$t('main.text343')">
                                <el-select v-model="add_form.type" disabled :placeholder="$t('main.text135')">
                                    <el-option label="111" value="111"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div></div>
                    </div>
                    <!-- 3 -->
                    <div class="d_row">
                        <div>
                            <el-form-item class="width_auto">
                                <div v-if="add_or_edit" class="sc_ntb border_set_color" @click="xingx_fun">
                                    <img v-if="xingx" class="xingx_img" src="../../../assets/img/xingx_yes.png" alt="">
                                    <img v-else class="xingx_img" src="../../../assets/img/xingx_no.png" alt="">
                                    {{$t('main.text393')}}
                                </div>
                            </el-form-item>
                        </div>
                        <div></div>
                    </div>
                    <!-- 4 -->
                    <div class="d_row">
                        <div>
                            <el-form-item class="width_auto">
                                <div v-if="add_or_edit" class="continue_btn" @click="add_form_btn2">{{$t('main.text394')}}</div>
                                <div v-else class="continue_btn" @click="add_form_btn">{{$t('main.text395')}}</div>
                            </el-form-item>
                        </div>
                        <div></div>
                    </div>
                    
                </el-form>

            </div>
        </div>
      
      </div>

      <!-- 删除 -->
    <el-dialog
        :visible.sync="delete_user_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../../assets/img/warning_icon.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text367')}}
        </div>
        <div class="log_out3">
          {{$t('main.text368')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="delete_user_dlg = false" class="cancel_btn border_set_color2">{{$t('main.text7')}}</el-button>
            <el-button type="primary" class="confirm_btn" @click="del_dlg_remove">{{$t('main.text369')}}</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import {crypto_addressList,withdraw_address_add,withdraw_address_edit,withdraw_address_del,withdraw_crypto_check} from '@/api/api';
export default {
    data() {
        return {
            checkList: [],
            xingx:false,
            delete_user_dlg:false,

            api_data_obj:{},
            currentPage: 1,//选中的页数
            page: 1, //分页 从 1 开始
            limit: 10, //每页条数
            page_total: 0, //一共多少条
            token_type:'',
            addr_box_show:false,
            add_form:{
                name:'',
                addr:'',
                type:'',
            },
            tableData:[],
            add_or_edit:true,//true 默认添加  false 编辑
            edit_item:{},
            old_edit_item:{},
            del_item:{}

        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    mounted() {
        sessionStorage.setItem('top_title_name',this.$t('main.text396'));
        let sess_data=JSON.parse(sessionStorage.getItem("jmhb_bz_1"));
        this.api_data_obj=sess_data;

        this.token_type=sess_data.token_type;
        this.add_form.type=this.set_type(sess_data.token_type);
        

        this.get_list();
        this.checkList=[];
    },
    methods: {
        checkbox_fun(item){
            this.checkList=[];
            this.checkList=[item.name];
            
            this.api_data_obj.details.name=item.name;
            this.api_data_obj.details.address=item.address;
            this.api_data_obj.details.type=this.token_type;
            // 星星 是否收藏
            sessionStorage.setItem("xingx",false);

            sessionStorage.setItem("jmhb_bz_1",JSON.stringify(this.api_data_obj));
            this.$router.push('/blockchain_w/new_digital_asset2');
        },
        set_type(v){
            // BTC - BTC
            // ETH - ETH
            // ERC - USDT-ERC20 USDC-ERC20
            // TRC - USDT-TRC20 USDC-TRC20
            // BSC - USDT-BSC20 USDC-BSC20
            if(v=='USDT-ERC20'||v=='USDC-ERC20'){
                return 'ERC';
            }else if (v=='USDT-TRC20'||v=='USDC-TRC20') {
                return 'TRC';
            }else if (v=='USDT-BSC20'||v=='USDC-BSC20') {
                return 'BSC';
            }else{
                return v;
            }
        },
        get_list(){
            if(this.token_type){
                crypto_addressList({
                    page:this.page,
                    limit:this.limit,
                    type:this.token_type
                }).then(res=>{
                    if (res.data.code==200) {
                        this.tableData=res.data.data.list;
                        this.page_total=res.data.data.count;
                        // console.log(res.data.data);
                    }
                })
            }
        },
        current_change(v){
            // console.log(v);
            this.page=v;
            this.limit=10;
            this.get_list();
        },
        add_btn(){
            this.add_form.name="";
            this.add_form.addr="";
            this.addr_box_show=true;
            this.add_or_edit=true;
            this.xingx=false;
            // 滚动到页面底部
            setTimeout(() => {
                this.bus.$emit('scroll_set');
            }, 100);
        },
        xingx_fun(){
            this.xingx=!this.xingx;
        },
        add_form_btn(){
            if (!this.add_form.name) {
                return this.message.ismessage('error',this.$t('main.text371'));
            }
            if (!this.add_form.addr) {
                return this.message.ismessage('error',this.$t('main.text372'));
            }
            if (this.add_or_edit) {
                withdraw_address_add({
                    name:this.add_form.name,
                    address:this.add_form.addr,
                    type:this.add_form.type,
                }).then(res=>{
                    if (res.data.code==200) {

                        this.api_data_obj.details.name=this.add_form.name;
                        this.api_data_obj.details.address=this.add_form.addr;
                        this.api_data_obj.details.type=this.token_type;
                        
                        sessionStorage.setItem("jmhb_bz_1",JSON.stringify(this.api_data_obj));
                        this.$router.push('/blockchain_w/new_digital_asset2');
                    }else{
                        this.message.ismessage('error',res.data.msg);
                    }
                })
            }else{
                // 编辑之前做判断

                if (
                    this.add_form.name==this.old_edit_item.name&&
                    this.add_form.addr==this.old_edit_item.address&&
                    this.add_form.type==this.old_edit_item.type
                ) {
                    this.addr_box_show=false;
                    return false;
                }

                withdraw_address_edit({
                    id:this.edit_item.id,
                    name:this.add_form.name==this.old_edit_item.name?'':this.add_form.name,
                    address:this.add_form.addr==this.old_edit_item.address?'':this.add_form.addr,
                    type:this.add_form.type==this.old_edit_item.type?'':this.add_form.type,
                }).then(res=>{
                    if (res.data.code==200) {
                        this.page=1;
                        this.limit=10;
                        this.currentPage=1;
                        this.get_list();
                        this.addr_box_show=false;
                        this.message.ismessage('success',this.$t('main.text375'));
                    }else{
                        this.message.ismessage('error',res.data.msg);
                    }
                })


            }
            
        },
        add_form_btn2(){
            if (!this.add_form.name) {
                return this.message.ismessage('error',this.$t('main.text371'));
            }
            if (!this.add_form.addr) {
                return this.message.ismessage('error',this.$t('main.text372'));
            }
            this.api_data_obj.details.name=this.add_form.name;
            this.api_data_obj.details.address=this.add_form.addr;
            this.api_data_obj.details.type=this.token_type;

            // 地址是否合法
            withdraw_crypto_check({
                address:this.add_form.addr,
                type:this.add_form.type
            }).then(res=>{
                if (res.data.code==200) {
                    // 星星 是否收藏
                    sessionStorage.setItem("xingx",this.xingx);
                    sessionStorage.setItem("jmhb_bz_1",JSON.stringify(this.api_data_obj));
                    this.$router.push('/blockchain_w/new_digital_asset2');
                }else{
                    this.message.ismessage('error',res.data.msg);
                }
            })
            
        },
        edit_fun(item){
            this.addr_box_show=true;
            this.add_or_edit=false;

            this.add_form.name=item.name;
            this.add_form.addr=item.address;
            this.add_form.type=item.type;
            this.edit_item=item;
            this.old_edit_item=JSON.parse(JSON.stringify(item));
            // 滚动到页面底部
            setTimeout(() => {
                this.bus.$emit('scroll_set');
            }, 100);
        },
        delete_fun(item){
            this.del_item=item;
            this.delete_user_dlg=true;
        },
        del_dlg_remove(){
            withdraw_address_del({
                id:this.del_item.id
            }).then(res=>{
                if (res.data.code==200) {
                    this.page=1;
                    this.limit=10;
                    this.currentPage=1;
                    this.get_list();
                    this.addr_box_show=false;
                    this.message.ismessage('success',this.$t('main.text376'));
                    this.delete_user_dlg=false;
                }else{
                    this.message.ismessage('error',res.data.msg);
                }
            })
        },


    }
}
</script>

<style scoped>
.step1{
    max-width: 521px;
    margin:10px auto 40px;
    /* background: pink; */
    display: flex;
    justify-content: space-between;
    text-align: center;
}
.s_img_box{
    position: relative;
    display: inline-block;
}
.s_img1{
    width: 44px;
}
.div1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    margin-top: 12px;
    color: #DEB981;
}
.s_img2{
    width: 135px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -151px;
}
/* 表格 */
.list_title1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.list_table{
    display: block;
    width: 100%;
}
.list_table>div{
    width: 100%;
    /* display: block; */
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.list_table>div:nth-child(odd){
    background: #39526F;
    border-radius: 12px;
}
.list_table>div>div{
    /* min-width: 130px; */
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    box-sizing: border-box;
    padding: 20px 28px;
}
.list_table div .td1{
    width: 20%;
}
.list_table div .td2{
    width: 50%;
    word-wrap: break-word;
}
.list_table div .td3{
    width: 10%;
}
.list_table div .td4{
    width: 20%;
}
.list_table .text_r{
    text-align: right;
}
.list_table .el-checkbox{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.list_table >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#fff;
    border-color:#fff;
    box-shadow: 0px 0px 0px 2px #39526F inset;
}
.list_table >>> .el-checkbox__inner{
    border-radius: 50%;
    background: transparent;
    width: 24px;
    height: 24px;
}
.list_table >>> .el-checkbox__inner::after{
    display: none;
}
.zdy_table_list{
    background: #314B69;
    border-radius: 16px;
}
.table_btm{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #041E35;
}
.table_btm2{
    box-sizing: border-box;
    padding: 28px;
}
.table_btm_t1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.add_btn,
.add_btn:hover,
.add_btn:focus,
.add_btn:active{
    min-width: 300px;
    height: 44px;
    color: #DEB981;
    border-color: #DEB981;
    background: transparent;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    border-style:solid;
    border-width: 1.5px;
    border-color:#ECBD75 #E3A84E #ECBC74 #F1C788;
}
.sand_img{
    width: 20px;
    cursor: pointer;
    vertical-align: middle;
}
.edit_btn{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #FFFFFF;
    margin-bottom: 10px;
    cursor: pointer;
}
.delete_btn{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #F35F65;
    cursor: pointer;
}
/* ---- */
.shuxian{
    width: 3px;
    margin: 20px 28px;
}
.d_row{
    display: flex;
    justify-content: space-between;
}
.d_row>div{
    width: 48%;
}
.table_btm3{
    padding-bottom: 6px;
}
.sc_ntb{
    min-width: 260px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    /* border: 1px solid #DEB981; */
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #DEB981;
    cursor: pointer;
    border-style:solid;
    border-width: 1.5px;
    border-color:#ECBD75 #E3A84E #ECBC74 #F1C788;
}
.width_auto{
    width: auto;
}
.xingx_img{
    width: 18px;
    margin-right: 13px;
    vertical-align: middle;
}
.inp_btm_txt{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 8px;
}
.continue_btn{
    cursor: pointer;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #04182A;
    min-width: 224px;
    height: 38px;
    text-align: center;
    line-height: 38px;
}
.no_data_text{
    text-align: center;
    display: inherit;
}
.alert_style{
    margin-bottom: 20px;
}
</style>

<style>
.operate_pop{
    min-width: 100px !important;
    background: #223C58;
    border-radius: 8px;
    border: none;
}
.operate_pop .popper__arrow{
    display: none;
}
</style>